var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 8.77778C7.66667 8.11851 7.86217 7.47404 8.22843 6.92588C8.59471 6.37771 9.11533 5.95048 9.72445 5.69818C10.3334 5.44589 11.0037 5.37988 11.6503 5.5085C12.2969 5.63711 12.8909 5.95458 13.357 6.42076C13.8232 6.88693 14.1407 7.48088 14.2693 8.12748C14.3979 8.77408 14.3319 9.44433 14.0796 10.0534C13.8273 10.6624 13.4001 11.1831 12.8519 11.5493C12.3038 11.9157 11.6592 12.1111 11 12.1111V13.2222M21 11C21 16.5229 16.5229 21 11 21C5.47716 21 1 16.5229 1 11C1 5.47716 5.47716 1 11 1C16.5229 1 21 5.47716 21 11Z",
    stroke: "#6F767D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.656b4cab75ff9bfacdd9f491ace18f29.svg";
export { ForwardRef as ReactComponent };